import * as i0 from '@angular/core';
import { ChangeDetectorRef, Component, ChangeDetectionStrategy, Inject, Self, NgModule } from '@angular/core';
import * as i2 from '@taiga-ui/cdk';
import { TuiDestroyService, TUI_PARENT_ANIMATION, TuiActiveZoneModule } from '@taiga-ui/cdk';
import { TuiHintService } from '@taiga-ui/core/services';
import { takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@tinkoff/ng-polymorpheus';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import * as i4 from 'rxjs';

class TuiHintsHostComponent {
    constructor(hints$, destroy$, cdr) {
        this.hints$ = hints$;
        this.destroy$ = destroy$;
        this.cdr = cdr;
        this.hints = [];
    }
    ngOnInit() {
        // Due to this view being parallel to app content, `markForCheck` from `async` pipe
        // can happen after view was checked, so calling `detectChanges` instead
        this.hints$.pipe(takeUntil(this.destroy$)).subscribe(hints => {
            this.hints = hints;
            this.cdr.detectChanges();
        });
    }
}
TuiHintsHostComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiHintsHostComponent, deps: [{ token: TuiHintService }, { token: TuiDestroyService, self: true }, { token: ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
TuiHintsHostComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiHintsHostComponent, selector: "tui-hints-host", host: { attributes: { "aria-live": "polite" } }, providers: [TuiDestroyService], ngImport: i0, template: "<div\n    *ngFor=\"let hint of hints\"\n    role=\"tooltip\"\n    @tuiParentAnimation\n    [tuiActiveZoneParent]=\"hint.activeZone || null\"\n>\n    <ng-container *polymorpheusOutlet=\"hint.component; context: {$implicit: hint}\"></ng-container>\n</div>\n", styles: [":host{position:fixed;top:0;left:0;width:100%;height:0}\n"], directives: [{ type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.TuiActiveZoneDirective, selector: "[tuiActiveZone]:not(ng-container), [tuiActiveZoneChange]:not(ng-container), [tuiActiveZoneParent]:not(ng-container)", inputs: ["tuiActiveZoneParent"], outputs: ["tuiActiveZoneChange"], exportAs: ["tuiActiveZone"] }, { type: i3.PolymorpheusOutletDirective, selector: "[polymorpheusOutlet]", inputs: ["polymorpheusOutlet", "polymorpheusOutletContext"] }], animations: [TUI_PARENT_ANIMATION], changeDetection: i0.ChangeDetectionStrategy.Default });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiHintsHostComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'tui-hints-host',
                    templateUrl: './hints-host.template.html',
                    styleUrls: ['./hints-host.style.less'],
                    // So that we do not force OnPush on custom hints
                    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
                    changeDetection: ChangeDetectionStrategy.Default,
                    providers: [TuiDestroyService],
                    animations: [TUI_PARENT_ANIMATION],
                    host: {
                        'aria-live': 'polite',
                    },
                }]
        }], ctorParameters: function () { return [{ type: i4.Observable, decorators: [{
                    type: Inject,
                    args: [TuiHintService]
                }] }, { type: i4.Observable, decorators: [{
                    type: Self
                }, {
                    type: Inject,
                    args: [TuiDestroyService]
                }] }, { type: i0.ChangeDetectorRef, decorators: [{
                    type: Inject,
                    args: [ChangeDetectorRef]
                }] }]; } });

class TuiHintsHostModule {
}
TuiHintsHostModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiHintsHostModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiHintsHostModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiHintsHostModule, declarations: [TuiHintsHostComponent], imports: [CommonModule, PolymorpheusModule, TuiActiveZoneModule], exports: [TuiHintsHostComponent] });
TuiHintsHostModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiHintsHostModule, imports: [[CommonModule, PolymorpheusModule, TuiActiveZoneModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiHintsHostModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PolymorpheusModule, TuiActiveZoneModule],
                    declarations: [TuiHintsHostComponent],
                    exports: [TuiHintsHostComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiHintsHostComponent, TuiHintsHostModule };
